import React from 'react'
import { CourseRoleForm } from '@Root/components'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import { courseRoleSelectors, courseRoleActions } from '@Store/studies'

export const CreateCourseRole = ({ onOpenDescriptionModal, parentURL }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { studyProgrammeId } = useParams()
  const courseRole = useSelector(courseRoleSelectors.courseRole)
  const options = useSelector(courseRoleSelectors.options)
  const isLoading = useSelector(courseRoleSelectors.isLoading)
  const errors = useSelector(courseRoleSelectors.errors)

  const onCreate = data => {
    dispatch(courseRoleActions.create({ data, history, studyProgrammeId }))
  }

  const onCancel = () => {
    history.length > 1 ? history.goBack() : history.push(parentURL)
  }

  return (
    <CourseRoleForm
      onOpenDescriptionModal={onOpenDescriptionModal}
      onSave={onCreate}
      onCancel={onCancel}
      canEdit={true}
      isNew
      initialValue={courseRole}
      options={options}
      isLoading={isLoading}
      initialErrors={errors}
    />
  )
}
